export default defineAppConfig({
  api: {
    cache: {
      // /{discover|news|pro}/{category}
      category: {
        cache: true,
        cacheOptions: {
          maxAge: 60 * 60, // 1 hour
        },
      },
      // /{discover|news|pro}/{category}/{subcategory}/{article}
      article: {
        cache: true,
        cacheOptions: {
          maxAge: 60 * 5, // 5 minutes
        },
      },
      relatedArticles: {
        cache: true,
        cacheOptions: {
          maxAge: 60 * 60, // 1 hour
          staleMaxAge: 24 * 60 * 60, // 24 hours
        },
      },
      categoryArticles: {
        cache: true,
        cacheOptions: {
          maxAge: 60 * 5, // 5 minutes
          staleMaxAge: 24 * 60 * 60, // 24 hours
        },
      },
      // /authors/{authorName}/articles
      authorArticles: {
        cache: true,
        cacheOptions: {
          maxAge: 60 * 60, // 1 hour
          staleMaxAge: 24 * 60 * 60, // 24 hours
        },
      },
    },
  },
  pages: {
    author: {
      widget: {
        shortBio: {
          title: 'Short bio',
          icon: 'identification-card-duotone',
        },
        expertise: {
          title: 'Expertise',
          icon: 'book-open-text-duotone',
        },
        education: {
          title: 'Education',
          icon: 'student-duotone',
        },
      },
    },
  },
})
